import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { GroupService } from '../group.service';
import { SectorService } from '../../sectors/sector.service';
import { Sector } from '../../../models/sector.model';

@Component({
  selector: 'app-create-group',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    CheckboxModule,
    SelectModule
  ],
  templateUrl: './create-group.component.html'
})
export class CreateGroupComponent implements OnInit, OnDestroy {
  @Input() id!: number | null;
  form!: FormGroup;
  @Output() formSubmitted = new EventEmitter<void>();
  @Output() modalClosed = new EventEmitter<void>();

  sectors: Sector[] = [];

  constructor(
    private fb: FormBuilder,
    private groupService: GroupService,
    private sectorService: SectorService
  ) {}

  ngOnDestroy(): void {
    this.modalClosed.emit();
  }

  ngOnInit(): void {
    this.sectorService.getAll('', false, null).subscribe({
      next: res => (this.sectors = res.data)
    });

    this.form = this.fb.group({
      description: ['', Validators.required],
      active: [true],
      sectorId: [null as number | null]
    });

    if (this.id) {
      this.getGroupData();
    }
  }

  getGroupData(): void {
    this.groupService.getById(this.id as number).subscribe({
      next: data => {
        this.form.patchValue({
          description: data.data.description,
          active: data.data.active,
          sectorId: data.data.sectorId ?? null
        });
      }
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return field ? field.invalid && (field.dirty || field.touched) : false;
  }

  onSubmit(): void {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(key => {
        this.form.get(key)?.markAsTouched();
      });
      return;
    }

    const v = this.form.getRawValue();
    const body = {
      description: v.description,
      active: v.active,
      sectorId: v.sectorId ?? null,
      useInPdv: false,
      image: '',
      printer: ''
    };

    if (this.id) {
      this.groupService.update(this.id, body).subscribe({
        next: () => this.formSubmitted.emit()
      });
    } else {
      this.groupService.create(body).subscribe({
        next: () => this.formSubmitted.emit()
      });
    }
  }
}
